import { useMemo } from 'react';

import { useSession } from '@ais-ui/websockets';
import { useCredentials } from '@ais-ui/auth';
import { useBasePath } from '@ais-ui/custom-hooks';

import { getBasePath } from './getAISBasePath';
import { Configuration, DatabaseLoaderApi } from '@ais-ui/api-spec/dbloader';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import { getAuthHeaderFromCredentials } from '@ais-ui/utils';

export const useDbloaderApi = () => {
  const credentials = useCredentials();
  const { sessionId } = useSession();
  const { protocol, hostname } = useBasePath();

  let basePath = getBasePath();
  let configuration: Configuration;
  if (hostname.includes('localhost')) {
    const username = credentials?.username || '';
    const password = credentials?.password || '';

    const authHeader = getAuthHeaderFromCredentials(username, password);
    configuration = new Configuration({
      basePath: `${basePath}api/dbloader`,
      headers: {
        'X-Application-Name': 'marinepulse',
        Authorization: authHeader,
      },
    });
  } else {
    basePath = `${basePath}aisweb/api/dbloader`;
    configuration = new Configuration({
      basePath: basePath,
      headers: {
        'Aisweb-Session': sessionId,
        'X-Application-Name': 'marinepulse',
      },
    });
  }

  const dbloaderApi = useMemo(
    () => new DatabaseLoaderApi(configuration),
    [configuration]
  );
  return dbloaderApi;
};

export const useDatabaseRange = (options = {}) => {
  const dbloaderApi = useDbloaderApi();

  return useQuery({
    queryKey: ['databaseRange'],
    queryFn: async () => {
      // Call the API endpoint
      const response = await dbloaderApi.dailyRangeGet();
      return response;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false, // Don't retry on 503 errors
  }, 'dbloader:databaseRange');
};
